import { jsx, jsxs } from 'react/jsx-runtime';
import { createElement } from 'react';
import { i18n } from '../../../utils/i18n.js';
import { useDimensions, Menubar, Tooltip } from '@tecsinapse/cortex-react';
import { clsx } from 'clsx';
import { AccountSettings } from '../../account-settings/index.js';
import { LanguageList } from '../../languages/ui/list.js';
import { NotificationList } from '../../notifications/ui/list.js';
import { BsMortarboard } from 'react-icons/bs';
import { GoQuestion } from 'react-icons/go';
import { Link } from 'react-router-dom';
import { useMenu } from '../hooks/useMenu.js';
import { useMenuTour } from '../hooks/useMenuTour.js';

const getEmptyItem = (item) => {
  return [{
    ...item,
    title: "Início"
  }];
};
const Menu = ({
  brandImageUrl,
  linkAcademia,
  showLanguages,
  changeUserLanguage,
  linkHelpTec,
  showNotifications,
  notificationCount,
  notifications,
  linkPortal,
  currentUser,
  logout,
  showMyAccount,
  decoratedMenuItems,
  locales,
  onCloseNotifications,
  customOptionsUser,
  setOnboardingShowed,
  showOnboarding
}) => {
  const {
    handleSearch,
    searchTerm,
    menuFiltered
  } = useMenu({
    decoratedMenuItems
  });
  const {
    width
  } = useDimensions();
  const ref = useMenuTour(setOnboardingShowed, showOnboarding);
  return /* @__PURE__ */ jsx(Menubar.Root, { children: /* @__PURE__ */ jsxs("div", { ref, children: [
    /* @__PURE__ */ jsxs(Menubar.Header, { className: clsx("items-center", width <= 640 && "justify-start"), "aria-label": "Abrir Menu", children: [
      /* @__PURE__ */ jsx(Menubar.HeaderLeft, { children: /* @__PURE__ */ jsx("a", { href: linkPortal, rel: "noreferrer", className: " cursor-pointer", children: /* @__PURE__ */ jsx("img", { src: brandImageUrl, alt: "brandLogo", className: "w-auto h-[70px] mx-kilo" }) }) }),
      /* @__PURE__ */ jsx(Menubar.Search, { defaultValue: searchTerm, onChange: handleSearch, className: "flex-row items-center mx-deca hidden sm:flex" }),
      /* @__PURE__ */ jsx(Menubar.HeaderRight, { "aria-label": "Barra de ferramentas", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-deca", children: [
        linkAcademia ? /* @__PURE__ */ jsx(Tooltip, { "aria-label": "Academia", text: i18n._(
          /*i18n*/
          {
            id: "MbVkgr"
          }
        ), children: /* @__PURE__ */ jsx("a", { href: linkAcademia, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx(BsMortarboard, { className: "text-secondary-medium", size: 24 }) }) }) : null,
        /* @__PURE__ */ jsx(Tooltip, { text: "Central de Relacionamento HelpTec", children: /* @__PURE__ */ jsx("a", { href: linkHelpTec, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx(GoQuestion, { className: "text-secondary-medium", size: 24 }) }) }),
        showLanguages ? /* @__PURE__ */ jsx(LanguageList, { locales: locales ?? [], idioma: currentUser.idioma, onLanguageChange: changeUserLanguage }) : null,
        /* @__PURE__ */ jsx(NotificationList, { showNotifications, notificationCount, notifications, linkPortal, onCloseNotifications }),
        /* @__PURE__ */ jsx(AccountSettings, { linkPortal, currentUser, logout, showMyAccount, customOptionsUser })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs(Menubar.Dropdown, { children: [
      width < 640 ? /* @__PURE__ */ jsx(Menubar.Search, { defaultValue: searchTerm, onChange: handleSearch, className: "mb-deca" }) : null,
      /* @__PURE__ */ jsx(Menubar.Categories, { children: menuFiltered.map((item, idx) => /* @__PURE__ */ jsx(Menubar.Category, { title: item.title, options: item.children ?? getEmptyItem(item), render: ({
        title,
        children,
        componentProps,
        isLinkComponent
      }) => {
        const propsItem = (children ?? []).length > 0 ? {} : {
          anchorProps: {
            ...componentProps,
            className: "no-underline"
          }
        };
        if (isLinkComponent) {
          return /* @__PURE__ */ jsx(Menubar.Item, { className: "flex flex-row items-center gap-x-deca", subItems: children ?? [], parentCategoryTitle: item.title, title, renderSubItems: ({
            title: titleSubItem,
            componentProps: subItemComponentProps
          }) => {
            return /* @__PURE__ */ jsx(Menubar.SubItem, { children: /* @__PURE__ */ jsx(Link, { to: subItemComponentProps.to, className: "no-underline text-secondary-dark text-sub", children: String(titleSubItem) }) }, `${titleSubItem}-${idx}`);
          }, children: (children ?? []).length > 0 ? /* @__PURE__ */ jsx("p", { children: String(title) }) : /* @__PURE__ */ jsx(Link, { to: componentProps.to, className: "no-underline text-secondary-dark", children: String(title) }) }, `${title}-${idx}`);
        }
        return /* @__PURE__ */ createElement(Menubar.Item, { ...propsItem, key: `${title}-${idx}`, className: "flex flex-row items-center gap-x-deca", subItems: children ?? [], parentCategoryTitle: item.title, title, renderSubItems: ({
          title: titleSubItem,
          componentProps: componentProps2
        }) => {
          return /* @__PURE__ */ jsx(Menubar.SubItem, { anchorProps: {
            ...componentProps2,
            className: "no-underline text-sub"
          }, children: String(titleSubItem) }, `${titleSubItem}-${idx}`);
        } }, String(title));
      } }, `${item.title}-${idx}`)) })
    ] })
  ] }) });
};

export { Menu };
